import Swiper from "swiper";
import { Autoplay, Pagination, Navigation, Thumbs } from "swiper/modules";
/**
 * @param swiperInit
 */
export function swiperInit() {
	new Swiper(".section-home-banner .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		loop: true,
		autoplay: {
			delay: 3500,
		},
		modules: [Pagination, Navigation, Autoplay],
		pagination: {
			el: ".section-home-banner .swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				const slide = this.slides[index];
				const title = slide.getAttribute("data-title") || `Slide ${index + 1}`;
				return `<span class="${className}">${title}</span>`;
			},
		},
		navigation: {
			nextEl: ".section-home-banner .btn-next",
			prevEl: ".section-home-banner .btn-prev",
		},
	});
	new Swiper(".section-home-design-your-own .swiper", {
		slidesPerView: 3,
		spaceBetween: 0,
		loop: true,
		speed: 2000,
		modules: [Autoplay],
		autoplay: {
			delay: 0,
			pauseOnMouseEnter: false, // added
			disableOnInteraction: false,
		},
		breakpoints: {
			768: {
				slidesPerView: 5,
			},
			1024: {
				slidesPerView: 6,
			},
			1200: {
				slidesPerView: 7,
			},
		},
	});
	// Reuseable Swiper
	$(".swiper-cols-1 .swiper").each(function () {
		const config = {
			touchMove: !this.hasAttribute("swiper-disable-touch-move"), // true if attribute absent, false if present
			autoplay: this.hasAttribute("swiper-autoplay"),
		};
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation, Autoplay],
			allowTouchMove: config.touchMove,
			...(config.autoplay && {
				autoplay: {
					delay: 3500,
				},
			}),
			speed: 1000,
			navigation: {
				nextEl: $(this).closest(".swiper-cols-1").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-1").find(".btn-prev")[0],
			},
		});
	});
	$(".swiper-cols-2 .swiper").each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation],
			navigation: {
				nextEl: $(this).closest(".swiper-cols-1").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-1").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		});
	});
	$(".swiper-cols-3 .swiper").each(function () {
		const config = {
			slidesPerView_sm: this.getAttribute("swiper-sm-slides") || 1,
			slidesPerView_md: this.getAttribute("swiper-md-slides") || 2,
			slidesPerView_lg: this.getAttribute("swiper-lg-slides") || 3,
			slidesPerView_xl: this.getAttribute("swiper-xl-slides") || 3,
			spaceBetween_sm: this.getAttribute("swiper-sm-padding") || 15,
			spaceBetween_md: this.getAttribute("swiper-md-padding") || 15,
			spaceBetween_lg: this.getAttribute("swiper-lg-padding") || 20,
			spaceBetween_xl: this.getAttribute("swiper-xl-padding") || 20,
			autoplay: this.hasAttribute("swiper-autoplay"),
		};
		console.log(this.hasAttribute("swiper-autoplay"));
		new Swiper(this, {
			slidesPerView: config.slidesPerView_sm,
			spaceBetween: config.spaceBetween_sm,
			modules: [Navigation, Pagination, Autoplay],
			...(config.autoplay && {
				autoplay: {
					delay: 3500,
				},
			}),
			navigation: {
				nextEl: $(this).closest(".swiper-cols-3").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-3").find(".btn-prev")[0],
			},
			pagination: {
				el: $(this).closest(".swiper-cols-3").find(".swiper-pagination")[0],
				type: "progressbar",
			},
			breakpoints: {
				768: {
					slidesPerView: config.slidesPerView_md,
					spaceBetween: config.spaceBetween_md,
				},
				1024: {
					slidesPerView: config.slidesPerView_lg,
					spaceBetween: config.spaceBetween_lg,
				},
				1200: {
					slidesPerView: config.slidesPerView_xl,
					spaceBetween: config.spaceBetween_xl,
				},
			},
		});
	});
	$(".swiper-cols-4 .swiper").each(function () {
		const config = {
			autoplay: this.hasAttribute("swiper-autoplay"),
		};
		new Swiper(this, {
			slidesPerView: 1.3,
			spaceBetween: 15,
			modules: [Navigation, Autoplay],
			...(config.autoplay && {
				autoplay: {
					delay: 3500,
				},
			}),
			navigation: {
				nextEl: $(this).closest(".swiper-cols-4").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-4").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
		});
	});
	new Swiper(".wrap-slide-featured-product .swiper", {
		slidesPerView: 1.2,
		spaceBetween: 20,
		modules: [Navigation, Pagination],
		pagination: {
			el: ".wrap-slide-featured-product .swiper-pagination",
			type: "progressbar",
		},
		navigation: {
			nextEl: ".wrap-slide-featured-product .btn-next",
			prevEl: ".wrap-slide-featured-product .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2.2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 4.02,
				spaceBetween: 20,
			},
		},
	});
	// **** Product Detail **** //
	const productDetailThumbs = new Swiper(".section-product-detail .slide-thumb .swiper", {
		spaceBetween: 12,
		slidesPerView: 4,
		breakpoints: {
			768: {
				spaceBetween: 11,
				slidesPerView: 4,
			},
			1024: {
				spaceBetween: 27,
				slidesPerView: 3,
				direction: "vertical",
			},
			1200: {
				spaceBetween: 27,
				slidesPerView: 4,
				direction: "vertical",
			},
		},
		on: {
			beforeInit: function (swiper) {
				const height = $(".section-product-detail.product-detail .slide-thumb").height();
			},
		},
	});
	const productDetailMain = new Swiper(".section-product-detail .slide-main .swiper", {
		slidesPerView: 1,
		spaceBetween: 16,
		modules: [Thumbs, Navigation],
		navigation: {
			nextEl: ".section-product-detail .slide-main .btn-next",
			prevEl: ".section-product-detail .slide-main .btn-prev",
		},
		thumbs: {
			swiper: productDetailThumbs,
		},
	});
}
